"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var form_management_service_1 = require("./form-management.service");
var Observable_1 = require("rxjs/Observable");
var http_1 = require("@angular/common/http");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var core_1 = require("@angular/core");
var FormManagementHttpService = /** @class */ (function (_super) {
    __extends(FormManagementHttpService, _super);
    function FormManagementHttpService(http, applicationPropertiesService, languageService) {
        var _this = _super.call(this, "form-service-url", http, applicationPropertiesService, languageService) || this;
        _this.http = http;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.languageService = languageService;
        _this.URL_FORMS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/forms"], ["", "/forms"])), "serviceUri");
        _this.URL_FORMS_WITH_PREFIX = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/", "/forms"], ["", "/", "/forms"])), "serviceUri", "prefix");
        return _this;
    }
    FormManagementHttpService.prototype.loadFormsByCategoryAndType = function (categorySystemName, type, prefix) {
        var _this = this;
        var data$ = this.serviceUri$
            .flatMap(function (formManagementServiceUrl) {
            var url = _this.getUrlForGettingData(formManagementServiceUrl, prefix);
            var params = new http_1.HttpParams()
                .set('categorySystemName', categorySystemName)
                .set('typeId', type.toString());
            return _this.http.get(url, { params: params });
        });
        return Observable_1.Observable.zip(data$, this.languages$).map(function (data) {
            return form_management_service_1.FormManagementService.deserializeServerResponse(data[0], data[1]);
        });
    };
    FormManagementHttpService.prototype.getUrlForGettingData = function (formManagementServiceUrl, prefix) {
        return !prefix ? this.URL_FORMS.replaceTemplate({ "serviceUri": formManagementServiceUrl }) :
            this.URL_FORMS_WITH_PREFIX.replaceTemplate({ "serviceUri": formManagementServiceUrl, "prefix": prefix });
    };
    FormManagementHttpService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    FormManagementHttpService.ctorParameters = function () { return [
        { type: idm_authentication_client_js_1.HttpClientWrapper, },
        { type: idm_application_properties_service_client_js_1.ApplicationPropertiesService, },
        { type: idm_message_language_service_client_js_1.LanguageService, },
    ]; };
    return FormManagementHttpService;
}(form_management_service_1.FormManagementService));
exports.FormManagementHttpService = FormManagementHttpService;
var templateObject_1, templateObject_2;
//# sourceMappingURL=form-management-http.service.js.map